import { IoChevronBackOutline } from "react-icons/io5";
import "./ProductsBuy.scss";
import Button from "../../Button/Button";
import { useEffect, useState } from "react";
import backgroundImage from "../../../assets/buying_options.png";
import { useAmplitude } from "../../../context/AmplitudeContext";
import { useUID } from "../../../context/UIDContext";

export const ProductsBuy = ({
  onBackClick,
  onOnlineShopClick,
  onStoreShopClick,
}) => {
  const [selectedPlace, setSelectedPlace] = useState("");
  const trackEvent = useAmplitude();
  const { uid } = useUID();

  useEffect(() => {
    trackEvent("webapp_user_visited_buy_mode_page", uid);
  }, [uid, trackEvent]);

  return (
    <div
      className="products-buy-page"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})`,
      }}
    >
      <div className="products-buy-page-header">
        <div className="product-buy-back-button-wrapper">
          <div className="back-icon" onClick={onBackClick}>
            <IoChevronBackOutline />
          </div>
        </div>
        <div className="product-buy-top-header">
          <img
            src="logo.png"
            alt="Perfect Hair"
            className="perfect-hair-logo"
          />
        </div>
      </div>
      <div className="product-buy-main-content">
        <h4 className="product-buy-title">
          Where would you like to buy our products?
        </h4>
        <div className="product-buy-buttons-container">
          <Button
            text="Discover online"
            onClick={() => setSelectedPlace("online")}
            usePrimaryColor={selectedPlace === "online"}
            isRounded={true}
            sameTextColor={true}
          />
          <Button
            text="Find in store"
            onClick={() => setSelectedPlace("store")}
            usePrimaryColor={selectedPlace === "store"}
            isRounded={true}
            sameTextColor={true}
          />
        </div>
      </div>
      <div className="product-buy-bottom-button">
        <Button
          text="Continue"
          onClick={() => {
            if (selectedPlace === "store") {
              onStoreShopClick();
            } else {
              onOnlineShopClick();
            }
          }}
          disabled={selectedPlace === ""}
        />
      </div>
    </div>
  );
};
